import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export const ConfidentialityIntro = (props: TypographyProps) => {
  return (
    <Typography {...props}>
      Pour vous faire profiter d’informations utiles, d’astuces pour optimiser vos charges et
      d’offres vous permettant de réaliser des économies, nous vous invitons à indiquer vos
      préférences ci-dessous. Quelques clics suffisent pour continuer à accéder à votre espace
      client… et ne rien manquer d’essentiel.
    </Typography>
  );
};
